/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
import React, { useState,useEffect,useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { AgGridReact } from 'ag-grid-react';
import { NGODatePicker,EditModal} from '../../../common';
import deleteIcon from '../../../assets/icons/deleteRole.svg';
import { PiSuitcaseLight } from "react-icons/pi";
import { FaRegCreditCard } from "react-icons/fa6";
import { PiMoneyFill } from "react-icons/pi";
import { LiaMoneyBillWaveAltSolid } from "react-icons/lia";
import LoadingGIF from '../../../assets/loadingIn.gif';
import { IoMdCard } from "react-icons/io";
import moment from 'moment';
import usePermissions from '../../../utils/userPermissions';
import { APIEndpoint} from "../../../utils/axios";
import CustomSelect from '../../../common/CustomSelect';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {formatDateByTimezone,getCultureFromLs} from '../../../utils/commonFunctions';
import CurrencyListing from '../currencyList';
  const filterData = {
    action: 4,
    collection: '',
    filterOperation: 'or',
    filters: [{ employeeType: 'crew' }],
    limit: 50,
    page: 1,
    searchParam: ''
  };
const RemarkFormFields = [
  { label: 'Comment', attribute: 'comment', type: 'textarea', required: true },
]
export const CrewDepositsPage = () => {
    const { ready } = useTranslation();
const firstLoad = React.useRef(true);
  const [state,setState] = useState({operatingDate:null,userSelected:null,isReloadTableData:false,cashDrawerList:[],addComment:false});
  const [crewMembers, setCrewMembers] = useState([]);
  const [exchangeRates, setExchangeRates] = useState([]);
  const [sectorsList,setSectorsList] = useState([]);
  const [catererLoading,setCatererLoading] = useState({caterer:false,passenger:false,editLoading:false});
  const [mode,setMode] = useState({edit:false,editId:null});
  const [passengersList,setPassengersList] = useState({});
  const [listingItems,setListingItems]=useState({count:0,items:[]});
  const [sectorSelectOptionsList,setSectorsSelectOptionsList]=useState([]);
  const [cardAndCashDetails,setCardAndCashDetails] = useState({card:0,cash:0});
  const [sectors,setSectors] = useState([]);
  const [cateringGroupList, setCateringGroupsList] = useState([]);
  const [cateringGroupSelected, setCateringGroupSelected] = useState(null);
  const [sectorSelected, setSectorSelected] = useState(null);
  const [cashDrawerSelected, setCashDrawerSelected] = useState(null);
  const [loadingUser, setLoadingUsers] = useState(false);
  const [cashSales, setCashSales] = useState({crewDeposits:{},passengerDeposit:0});
  const [passengers, setPassengers] = useState([{ sector: null, passenger: null, amount: '' }]);
  const [cardSalesDeclared, setCardSalesDeclared] = useState('');
  const [currencyRows,setCurrencyRows] = useState([]);
  const [message,setMessage] = useState({text:""});
  const [totalSalesFromPOS,setTotalSalesFromPOS] = useState(0);
   const [totalDepositByCrew, setTotalDepositByCrew] = useState(0);
   const [cardSalesFromPOS,setCardSalesFromPOS]=useState(0);



  const { hasPermission: viewCashDeposits  } = usePermissions('view', 'cashregister.deposit');
  const { hasPermission: createDeposit } = usePermissions('create', 'cashregister.deposit');
  const { hasPermission: editDeposit } = usePermissions('edit', 'cashregister.deposit');

  const { hasPermission: deleteRefunds } = usePermissions('delete', 'cashregister.refund');
  const { hasPermission: viewRefunds } = usePermissions('view', 'cashregister.refund');
  const { hasPermission: createRefund } = usePermissions('create', 'cashregister.refund');
  const { hasPermission: editRefund } = usePermissions('edit', 'cashregister.refund');


  const columns=[
    { field: 'code', headerName: 'Code',resizable:true, minWidth: 150,flex:1, },
    { field: 'cashDrawer.airport.locationName', headerName: 'Uplift Location',resizable:true, minWidth: 100,flex:1, },
      { field: 'targetDate', headerName: 'Uplift Time',valueGetter: (params) => {
            return params?.data ?  moment(params.data?.targetDate).tz(getCultureFromLs()?.timezone.name).format('DD-MM-YYYY'):null
          },resizable:true, minWidth: 100,flex:1},
    { field: 'createdAt', headerName: 'Created At',valueGetter: (params) => {
            return params?.data ?  moment(params.data?.createdAt).tz(getCultureFromLs()?.timezone.name).format('DD-MM-YYYY hh:mm A'):null
          },resizable:true, minWidth: 130,flex:1},
    { field: 'createdBy.employeeName', headerName: 'Created By',resizable:true, minWidth: 110,flex:1, },
    { field: 'totalCardSales', headerName: 'Total Card Sales',cellStyle: params => {
       if(params.value<0){
        return {color: '#ef3e39',fontWeight:"700"};
       }else if(params.value>0){
        return {color: '#ffffff'};
       }else{
        return null;
       }
      },
valueGetter: (params) => {
  if (params?.data && params.data.totalCardSales != null) {
    return Number(params.data.totalCardSales).toFixed(2);
  }
  return null;
},resizable:true, minWidth: 110,flex:1, },
    { field: 'totalCashSales', headerName: 'Total Cash Sales',cellStyle: params => {
       if(params.value<0){
        return {color: '#ff443dff',fontWeight:"700"};
       }else if(params.value>0){
        return {color: '#ffffff'};
       }else{
        return null;
       }
      },
valueGetter: (params) => {
  if (params?.data && params.data.totalCashSales != null) {
    return Number(params.data.totalCashSales).toFixed(2);
  }
  return null;
},resizable:true, minWidth: 110,flex:1, },
    {
  field: 'totalDeposited',
  headerName: 'Deposit Captured',
  cellStyle: params => {
    if (params.value < 0) {
      return { color: '#ff443dff', fontWeight: "700" };
    } else if (params.value > 0) {
      return { color: '#ffffff' };
    } else {
      return null;
    }
  },
valueGetter: (params) => {
  if (params?.data && params.data.totalDeposited != null) {
    return Number(params.data.totalDeposited).toFixed(2);
  }
  return null;
},
  resizable: true,
  minWidth: 110,
  flex: 1,
}
  ]



  const showToast = useCallback(()=>{
        toast.dismiss();

        if (message.text) {
          toast.success(message.text, {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
            pauseOnHover: true,
            draggable: false,
            autoClose: 2000,
            style: {
              backgroundColor: '#4cae4c',
              color: '#fff',
              borderRadius: '8px',
              fontSize: '1rem',
            }
          });
        } else if (message.error) {
          toast.error(message.error, {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
            pauseOnHover: true,
            draggable: false,
            autoClose: 2000,
            style: {
              backgroundColor: '#d9534f',
              color: '#fff',
              borderRadius: '8px',
              fontSize: '1rem',
              width:'30rem'
            }
          });
        } else {

        }
      },[message])

        useEffect(() => {
          if (!message.text && !message.error) return;
          showToast();
          const timer = setTimeout(() => {
            setMessage({ text: "" });
          }, 2000);
      
          return () => clearTimeout(timer);
        }, [message.text, message.error, showToast]);

useEffect(() => {
  if (firstLoad.current) {
    firstLoad.current = false;
     fetchCurrencyEntity();
      fetchDepositSectors().catch((error) => {
        console.error('Error fetching deposit sectors:', error);
      });
    Promise.allSettled([getEmployeesAll(), fetchCashDrawersList()]);
  }
}, []);

useEffect(() => {
if(cateringGroupSelected || state?.userSelected){
  fetchSectors(cateringGroupSelected?.value);
fetchSalesSummary(cateringGroupSelected?.value);
fetchRotationSalesSummary(cateringGroupSelected?.value);
fetchCashDeposits();
}
if(!cateringGroupSelected || !cashDrawerSelected || !state.userSelected){
    setSectorSelected(null);
    setPassengersList({});
    setSectorSelected(null);
    setSectorsList([]);
    setPassengers([{ sector: null, passenger: null, amount: '' }]);
    setSectorsSelectOptionsList([]);
    setCardSalesDeclared("");
}
if(state.cashDrawerList && state.cashDrawerList?.length===1){
  setCashDrawerSelected(state.cashDrawerList[0]);
}
if(!mode.edit && !mode.editId){
  setCashSales({
     crewDeposits:{},
     passengerDeposit: 0,
    });
}
  
listItemsLabel();
setListingItems({count:0,items:[]});
}, [cateringGroupSelected,cashDrawerSelected,state.userSelected,state.cashDrawerList,sectors]);


  useEffect(() => {
    if((state.operatingDate || state.userSelected || cateringGroupSelected) && !firstLoad.current ){
       fetchCurrencyEntity();
      fetchDepositSectors().catch((error) => {
        console.error('Error fetching deposit sectors:', error);
      });
    }
  }, [state.operatingDate,state.userSelected,cateringGroupSelected]);

useEffect(() => {
  if (!sectorSelected && sectorSelectOptionsList?.length > 0) {
    setSectorSelected(sectorSelectOptionsList[sectorSelectOptionsList.length - 1]);
  }
}, [sectorSelectOptionsList, sectorSelected,sectors]);

  useEffect(() => {
    if (!cashSales) return;
if(mode.edit && catererLoading.editLoading)return;
    let total = Object.values(cashSales.crewDeposits || {}).reduce(
      (sum, val) => sum + val,
      0
    );

    total -= Number.isNaN(Number(cashSales.passengerDeposit))
      ? 0
      : Number(cashSales.passengerDeposit);

    total = parseFloat(total.toFixed(2));

    if (total === 0) {
      total = 0;
    }

    setTotalDepositByCrew(total);
  }, [cashSales]);

const fetchSectors = async (id) => {

const isSectorsEmptyMap = sectors instanceof Map && sectors.size === 0;
const isSectorsUndefined = typeof sectors === 'undefined';
const isSectorsNull = sectors === null;
const isIdInvalid = !id;
const isSectorsEmptyArray = Array.isArray(sectors) && sectors.length === 0;
if (isSectorsEmptyMap || isSectorsUndefined || isSectorsNull || isIdInvalid || isSectorsEmptyArray)
  return;
const sectorArraySelected = sectors?.get(id);
if (sectorArraySelected && sectorArraySelected.length) {
    const list = sectorArraySelected.map((item, index) => ({
      key: index + 1,
      label: `${item.flightNumber}-${item.origin}-${item.destination}`,
      value: item.id,
    }));

    setSectorsSelectOptionsList(list);
    setSectorsList(sectorArraySelected);

    return list; 
  }

  return [];
}

const fetchCurrencyEntity = useCallback(async () => {
  try {
    const date = moment(formatDateByTimezone(state.operatingDate ? new Date(state.operatingDate) : new Date())).format("YYYY-MM-DD");

    const bodyCurrency = { date };

    const [resIbr, resActCurrency] = await Promise.all([
      APIEndpoint.post("operations/ibrExchange/rates", bodyCurrency),
      APIEndpoint.post("operations/currencies/find", bodyCurrency),
    ]);

    if (resIbr && resActCurrency.currencies.length) {
      const uniqueArray = [...new Set(resActCurrency.currencies)];
      if(uniqueArray.length && getCultureFromLs().currency.code.length){
      const homeCurrency= getCultureFromLs().currency.code;
      const indexCurrency= uniqueArray.indexOf(homeCurrency);
      if(indexCurrency > 0){
        const [item] = uniqueArray.splice(indexCurrency,1);
        uniqueArray.unshift(item);
      }else{
        uniqueArray.unshift(homeCurrency);
      }
      }
   setExchangeRates(new Map(resIbr.rates?.items.map(rt => [`${rt.fromIsoCode}_${rt.toIsoCode}`,rt.rate]) || []));
      setCurrencyRows(uniqueArray);
    }
  } catch (error) {
    console.error("Failed to fetch currency data:", error);
  }
}, [state.operatingDate]);

const getEmployeesAll = useCallback(async () => {
  setLoadingUsers(true);
  try {
    const initialRes = await fetchEmployees(1, 1);
    const total = initialRes?.count || 0;

    if (total > 0) {
      const fullRes = await fetchEmployees(1, total);

      if (Array.isArray(fullRes?.items) && fullRes.items.length) {
        const formattedEmployees = fullRes.items.map((item, index) => ({
          key: item.employeeId,
          label: `${item.employeeCode} - ${item.name}`,
          value: item.employeeCode,
        }));
        setCrewMembers(formattedEmployees);
      }
    }
  } catch (error) {
    console.error("Failed to fetch employees:", error);
  } finally {
    setLoadingUsers(false);
  }
}, []);

const fetchCashDrawersList = useCallback(async () => {
  try {
    const res = await APIEndpoint.get("cashRegister/cashDrawers");
    const list =
      res?.result?.map((drawer, index) => ({
        key: index,
        label: drawer.value,
        value: drawer.id,
      })) || [];


   setState((prev) => ({ ...prev, cashDrawerList: list }));
  } catch (error) {
    console.error("Failed to fetch cash drawers:", error);
  }
}, []);


  const fetchSalesSummary = useCallback(
    async (data) => {
      const { flightNumber, origin, destination, std } = data || {};
  
      if (!flightNumber) return;
      setCatererLoading((_)=>({..._,caterer:false,passenger:true}));
      try {
        const res = await APIEndpoint.post("operations/manifests", {
          sectors: [
            {
              flightNumber,
              origin,
              destination,
              flightDate: moment(
                formatDateByTimezone(new Date(std), false)
              ).format("YYYY-MM-DD"),
            },
          ],
        });
        if (res?.manifests?.length) {
        setPassengersList(() => {
          const manifest = res.manifests?.[0];
          if (!manifest) return; 
          return {
            ...manifest,
            pasngrs: manifest.passengers
              .filter(psr => psr.seatNo !== null)
              .map((m) => ({
                key: m.passengerId,
                label: `${m.name} (${m.seatNo} - ${m.pnr})`,
                value: m.passengerId,
              })),
          };
        });
      setCatererLoading((_)=>({..._,caterer:false,passenger:false}));


        }
      } catch (err) {
      setCatererLoading((_)=>({..._,caterer:false,passenger:false}));


        console.error("Sales summary fetch failed", err);
      }
    },
    [state.userSelected, cateringGroupSelected]
  );

  const fetchRotationSalesSummary = useCallback(
    async (id) => {
      if (!id) return;
      try {
        const res = await APIEndpoint.post(`operations/rotations/${id}/sales`, {
          employeeCode: state.userSelected?.value ?? null,
        });
        if (res) {
          setCardAndCashDetails({
            card:
              res.card.totalConvertedAmount || res.card.totalAmount || 0,
            cash:
              res.cash.totalConvertedAmount || res.cash.totalAmount || 0,
          });
        }
      } catch (err) {
        console.error("Rotation sales summary fetch failed", err);
      }
    },
    [state.userSelected, cateringGroupSelected]
  );
const fetchCashDeposits = useCallback(async () => {
  if (fetchCashDeposits.loading) return; 
  fetchCashDeposits.loading = true;

  try {
    const res = await APIEndpoint.post("cashRegister/v2/deposits/find", {
      cashDrawerId: cashDrawerSelected?.value ?? null,
      targetDate: formatDateByTimezone(state.operatingDate ? new Date(state.operatingDate) : new Date(), false),
      employeeId: state.userSelected?.key ?? null,
      employeeCode: state.userSelected?.value ?? null,
      cateringRotationId: cateringGroupSelected?.value ?? null,
    });
    if (res) setListingItems({ count: res.count, items: res.items });
  } catch (err) {
    console.error("Cash deposits fetch failed", err);
  } finally {
    fetchCashDeposits.loading = false;
  }
}, [
  cashDrawerSelected?.value,
  state.operatingDate,
  state.userSelected?.key,
  state.userSelected?.value,
  cateringGroupSelected?.value
]);

const fetchDepositSectors = useCallback(async () => {
      setCatererLoading((_)=>({..._,caterer:true,passenger:false}));

  try {

    const body1 = {
      date: formatDateByTimezone(state.operatingDate ? new Date(state.operatingDate) : new Date(), true),
      employeeCode: state.userSelected?.value??null
    };

    const body = {
      targetDate: formatDateByTimezone(state.operatingDate ? new Date(state.operatingDate) : new Date(), false),
      employeeId: state.userSelected?.key
    };
    const promises = [
      APIEndpoint.post("operations/rotations/find", body1),
      state.userSelected ? APIEndpoint.post("cashRegister/getDepositPendingSectors", body) : null 
    ].filter(Boolean); 

    const [resRotation, resDeposits] = await Promise.all(promises);

    if (resRotation || resDeposits) {
      if(resRotation?.rotations && resRotation?.rotations?.length){
        const sectorsLookUp = new Map(resRotation.rotations.map(it=>[it.id,it.legs]));
      if (sectorsLookUp) {
       const list =
        resRotation?.rotations?.map((rot, index) => ({
          key: index,
          label: rot.name,
          value: rot.id,
        })) || [];
       setCateringGroupsList(list);
       setSectors(sectorsLookUp);
      }
      }else{
        setCateringGroupSelected(null);
         setCateringGroupsList([]);
          setSectorSelected(null);
      }
      setCatererLoading((_)=>({..._,caterer:false,passenger:false}));

    } 

  } catch (error) {
   setCatererLoading((_)=>({..._,caterer:false,passenger:false}));


    console.error("Failed to fetch currency data:", error);
  }
}, [state.userSelected, state.operatingDate]);

const getRate = (from, to) => {
  if (from === to) return 1;
  return exchangeRates.get(`${from}_${to}`) ?? 1;
};

const handleCashSaleChange = (currency, value) => {
  const homeCurrency = getCultureFromLs().currency.code;
  const rate = getRate(currency, homeCurrency);

  setCashSales(prev => ({
    ...prev,
    crewDeposits: {
      ...prev.crewDeposits,
      [currency]: parseFloat(rate * value) || 0
    },
    [currency]: value
  }));
};

const onDateChange=(e)=>{
    setState( (_prev) => {
        return { ..._prev,operatingDate:e.target.value}
      });
}
  const addPassenger = () => {
    setPassengers([...passengers, { sector: null, passenger: null, amount: '' }]);
  };

const updatePassenger = async (index, field, value, passengerFind = false) => {

  setPassengers((prev) => {
    const updatedPassengers = [...prev];
    updatedPassengers[index] = {
      ...updatedPassengers[index],
      [field]: value,
    };
    if (field === 'amount') {
      const totalPassengerDeposit = updatedPassengers.reduce((sum, p) => {
        const amt = parseFloat(p.amount) || 0;
        return sum + amt;
      }, 0);

      setCashSales((prevSales) => ({
        ...prevSales,
        passengerDeposit: totalPassengerDeposit,
      }));
    }

    return updatedPassengers;
  });

  if (value && passengerFind && sectorsList.length) {
    const sectorDet = sectorsList.find((st) => st.id === value.value);
    if (sectorDet) {
      await fetchSalesSummary(sectorDet);
    }
  }
};

const removePassenger = (index) => {
  const updatedPassengers = passengers.filter((_, i) => i !== index);
  const totalPassengerDeposit = updatedPassengers.reduce((sum, p) => {
    const amt = parseFloat(p.amount) || 0;
    return sum + amt;
  }, 0);

  setPassengers(updatedPassengers);
  setCashSales(prev => ({
    ...prev,
    passengerDeposit: totalPassengerDeposit,
  }));
};

async function fetchEmployees(page=1, perPage=1,searchKey=''){
  filterData.page = page;
  filterData.limit = perPage;
  filterData.searchParam = searchKey;
  try {
    const res=await APIEndpoint.post('employees/process',filterData);
    return res;
  } catch (error) {
    console.error("Failed to fetch employees:", error);
  }
}



let difference = ((totalSalesFromPOS + cardAndCashDetails.cash) - totalDepositByCrew).toFixed(2);
 difference = parseFloat(difference) === 0 ? 0 : difference;
let cardDifference = ((cardSalesFromPOS + cardAndCashDetails.card) - cardSalesDeclared).toFixed(2);
 cardDifference = parseFloat(cardDifference) === 0 ? 0 : cardDifference;

const currencyListingProps={
  currencyRows,
    cashSales,
handleCashSaleChange
}
const handleUpdatedRemarks=(e,update)=>{
  setState((_)=>({..._,addComment:false}))

}
const closeModal=()=>{
  setState((_)=>({..._,addComment:false}))
}



const saveUserDeposits = async () => {
  setMessage({ text: "" });
  if (cashDrawerSelected && state.userSelected && cateringGroupSelected && sectorSelected) {
    let refundDetails = [];
    const sectorDet = sectorsList.find(st => st.id === sectorSelected.value);

    const { std,flightNumber, origin, destination } = sectorDet || {};

    if (!sectorDet) {
       return;
    }
if (passengersList?.passengers?.length > 0 && passengers?.length > 0) {

  const { flightNumber, origin, destination, flightDate } = passengersList || {};

     refundDetails = passengers.map(psng => {
      const passengerDet = passengersList.passengers.find(pngL => psng?.passenger?.value === pngL.passengerId?.toString());

      if (!passengerDet) return null; 

      const { status, pnr, name, title, passengerId, seatNo } = passengerDet;

      return {
        flightNumber,
        origin,
        destination,
        flightDate: formatDateByTimezone(flightDate, false),
        status,
        pnr,
        name,
        title:title??"",
        passengerId: passengerId.toString(),
        seatNo,
        currency: getCultureFromLs().currency.code,
        amount: parseFloat(psng.amount),
      };
    })
    .filter(Boolean); 
}


    const body = {
      cashDrawerId: cashDrawerSelected.value,
     ...(!mode.edit ? {targetDate: formatDateByTimezone(state.operatingDate ? new Date(state.operatingDate) : new Date(), false)}:{}),
     ...(!mode.edit ? {employeeId: state.userSelected.key}:{}),
    ...(!mode.edit ?{ cateringRotationId: cateringGroupSelected?.value}:{}),
      sectors: [
        {
          flightNumber,
          origin,
          destination,
          flightDate: moment(formatDateByTimezone(new Date(std), false)).format('YYYY-MM-DD'),
        },
      ],

      items: (() => {
        const entries = Object.entries(cashSales);
        const filteredEntries = entries.filter(([key]) => key !== 'crewDeposits' && key !== 'passengerDeposit');
        const mappedItems = filteredEntries.map(([key, value]) => ({
          currencyCode: key,
          amount: parseFloat(value),
        }));
        const validItems = mappedItems.filter(item => !isNaN(item.amount));
        return validItems;
      })(),
      totalCashSales: isNaN(parseFloat(totalDepositByCrew)) ? 0 : parseFloat(totalDepositByCrew),
     totalCardSales: isNaN(parseFloat(cardSalesDeclared)) ? 0 : parseFloat(cardSalesDeclared),
      refunds: refundDetails,
    };
    if(!body.items.length){
      setMessage({ error: `Must contain at least 1 crew currency deposit` });
            return;
    }

    try {
      const res = !mode.edit? await APIEndpoint.post(`cashRegister/v2/deposits`, body):await APIEndpoint.put(`cashRegister/v2/deposits/${mode.editId}`, body);
      if (res?.message) {
        toast.success(res.message || "Success");
        setCateringGroupSelected(null);
        if(mode.edit){
          setState((_)=>({..._,userSelected:null,addComment:false})); 
          setCashDrawerSelected(null);
          setMode({edit:false,editId:null});
        }
      }
    } catch (error) {
      setMessage({ error: error?.message || 'Failed to save deposits' });
    }
  } else {
    setMessage({ error: "Cash drawer or Catering group is missing" });
  }
};      

const onRowClicked = async (e) => {
  const { id } = e.data || {};
  if (!id) return;
  setCatererLoading((_)=>({..._,editLoading:true}));
  try {
    const res = await APIEndpoint.get(`cashRegister/v2/deposits/${id}`);
    const deposit = res?.cashDeposit;
    if (!deposit) return;

    const {
      id: depositId,
      cashDrawer,
      cateringRotationId,
      crew,
      items = [],
      refunds = [],
      sectors = [],
      targetDate,
      totalCashSales,
      totalCardSales,
      totalDeposited,
    } = deposit;

    setTotalSalesFromPOS(totalCashSales.toFixed(2));
    setTotalDepositByCrew(totalDeposited.toFixed(2));
    setCardSalesFromPOS(totalCardSales.toFixed(2));
    setMode({ edit: true, editId: depositId });
    setState((prev) => ({
      ...prev,
      operatingDate: new Date(targetDate),
      userSelected: {
        key: crew.employeeId,
        label: `${crew.employeeCode} - ${crew.employeeName}`,
        value: crew.employeeCode,
      },
    }));

    setCashDrawerSelected(state?.cashDrawerList?.find((ctr) => ctr.value === cashDrawer.id) || null);
    setCateringGroupSelected(cateringGroupList.find((ctr) => ctr.value === cateringRotationId) || null);

    if (items.length > 0) {
      items.forEach((it) =>
        handleCashSaleChange(it.currencyCode, it.amount.toString())
      );
    }

let sectorOptions = sectorSelectOptionsList;

if ((!sectorOptions.length) && cateringRotationId) {
  sectorOptions = await fetchSectors(cateringRotationId); 
}

if (refunds?.length) {
  await new Promise((resolve) => {
    setPassengers((prev) => {
      const newPassengers = Array.from(
        { length: Math.max(prev.length, refunds.length) },
        (_, i) => prev[i] || { sector: null, passenger: null, amount: '' }
      );
      setTimeout(resolve, 0);
      return newPassengers;
    });
  });

  const sectorMap = new Map(sectorOptions.map((s) => [s.label, s]));

  for (const [index, rf] of refunds.entries()) {
    const { pnr, passengerId, seatNo, name, flightNumber, origin, destination, amount } = rf;
    const sectSel = sectorMap.get(`${flightNumber}-${origin}-${destination}`);

    if (sectSel) {
      await updatePassenger(index, 'sector', sectSel, true);
      await updatePassenger(index, 'passenger', {
        key: passengerId,
        label: `${name} (${seatNo} - ${pnr})`,
        value: passengerId,
      }, false);
      await updatePassenger(index, 'amount', amount.toString(), false);
    }
  }
}


    if (sectors?.length > 0) {
      const firstMatch = sectorSelectOptionsList.find((st) =>
        sectors.some(
          (rf) =>
            st.label === `${rf.flightNumber}-${rf.origin}-${rf.destination}`
        )
      );
      if (firstMatch) setSectorSelected(firstMatch);
    }
  } catch (err) {
    console.error('deposit fetch failed', err);
  }finally{
  setCatererLoading((_)=>({..._,editLoading:false}));
  }
};


const listItemsLabel = () => {
  const formattedDate = moment(formatDateByTimezone(state.operatingDate ?? new Date(), false)).format('DD-MM-YYYY');
    if (cateringGroupSelected) {
      return `${formattedDate}  ${cateringGroupSelected.label}`;
    } else if (cashDrawerSelected || state.userSelected) {
      return `${formattedDate}  ${state.userSelected?.label ?? cashDrawerSelected.label}`;
    }

};

  return (
    <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">

  <div className="crew-sales-container" style={{ overflowY:'auto',height:'calc(100vh - 215px)'}}>
      <div className="crew-sales-deposit">       
        <div className="form-row content-tabs">
          <div className='content-tabs form-row flexRow justifyContentFlexStart'>
          <div className="form-group">
            <label className='reqm'>Operating Date</label>
                    <button className="orderStatus-div">
                      <>
                              <NGODatePicker
                                style={{width: '8rem',border:'0.7px solid #fff',margin:0}}
                                value={state.operatingDate?new Date(state.operatingDate):new Date()}
                                dateFormat="dd/MM/yyyy"
                                name='operatingDate'
                                className='padding0'
                                isclearable={!mode.edit}
                                isDisabled={mode.edit}
                                placeholder={'Operating Date'}
                                placeholdertext={'Operating Date'}
                                onChange={onDateChange} />
                            </>
                      </button>
          </div>

          <div className="form-group">
            {state ? (
            <div className="form-group">
         
            <label>Cash Drawer</label>
           
         <CustomSelect
          options={state?.cashDrawerList}
          placeHolder="Search Cash Drawer..."
           width={'13rem'}
           isDisabled={mode.edit?true:false}
           value={cashDrawerSelected}
          onChange={(val)=>setCashDrawerSelected(val)}
          />
  
          </div>):<></>}

          </div> 
          <div className="form-group">
            {state && crewMembers.length ? (
            <div className="form-group">
            
            <label>Crew Member</label>
           
          <CustomSelect
          options={crewMembers}
          placeHolder="Search Crew Member..."
          width={'13rem'}
          isDisabled={loadingUser || mode.edit}
          value={state.userSelected}
          onChange={(val)=>setState((_)=>({..._,userSelected:val,filtersSelected:true}))}
          />
      
          </div>):<></>}

          </div>

          <div className="form-group">
            {state && !state.crewMember ? (
            <div className="form-group">
           <div className='flexRow'>
            <label className='reqm'>Catering Group  </label>
          {catererLoading.caterer ?<img src={LoadingGIF} className='' style={{width:'16px',height:'16px'}} alt="Loading" />:<></>}
            </div>
           
          <CustomSelect
          options={cateringGroupList}
          placeHolder="Search Catering Group..."
          width={'13rem'}
          isDisabled={catererLoading.caterer || mode.edit}
          value={cateringGroupSelected}
          onChange={(val)=>setCateringGroupSelected(val)}
          />

          </div>):<></>}

          </div>
          </div>

        </div>

{viewCashDeposits?<CurrencyListing currencyListingProps={currencyListingProps}/>:null}

       { <div className="totals-section">
          <div className="total-box">
            <label>Total Sales from POS ({getCultureFromLs().currency.code})</label>
            <div className="total-value">
              <PiMoneyFill/>
              <span>{totalSalesFromPOS}</span>
            </div>
          </div>

          <div className="total-box">
            <label>Total Deposit by Crew ({getCultureFromLs().currency.code})</label>
            <div className="total-value">
              <LiaMoneyBillWaveAltSolid />
              <span>{totalDepositByCrew}</span>
            </div>
          </div>

          <div className={`total-box ${parseFloat(difference) > 0 ? 'alt-up' : parseFloat(difference) < 0 ? 'alt-down' : ''}`}>
            <label>Difference</label>
            <div className="total-value">
              <span>{difference}</span>
            </div>
          </div>
        </div>}
      </div>

     {viewRefunds? <div className="passengers-section">
        <span className='large-button-text-medium'>Amount Paid Back to Passenger</span>
        
        {passengers.map((passenger, index) => (
          <div key={index} className="passenger-row margTop16">
            <div className="form-group">
              <label className='reqm'>Sector</label>
               <div className="margTop7"></div>
         <CustomSelect
          options={sectorSelectOptionsList}
          placeHolder="Search Sectors..."
          autoWidth={true}
          isDisabled={!editRefund}
          value={passenger.sector}
          onChange={(val)=>updatePassenger(index, 'sector', val,true)}
          />
            </div>

            <div className="form-group">
              <div className='flexRow'>
            <label className='reqm'>Passenger</label>
          {catererLoading.passenger?<img src={LoadingGIF} className='' style={{width:'16px',height:'16px'}} alt="Loading" />:<></>}
            </div>
               <div className="margTop7"></div>
         <CustomSelect
          options={passengersList?.pasngrs}
          placeHolder="Search Passenger..."
          autoWidth={true}
          value={passenger.passenger}
          isDisabled={catererLoading.passenger || !editRefund}
          onChange={(val)=>updatePassenger(index, 'passenger', val,false)}
          />
            </div>

            <div className="flexRow form-group">
              <label className='reqm'>Amount ({getCultureFromLs().currency.code})</label>
              <div className="amount-input-wrapper">
                <input
                  type="number"
                  step="1"
                  disabled={!editRefund}
                  className='edit-input-passenger-mant'
                  value={passenger.amount}
                  onChange={(e) => updatePassenger(index, 'amount', e.target.value,false)}
                  placeholder="0"
                />
            {deleteRefunds? <button 
                  className="delete-btn"
                  disabled={passengers.length === 1}
                >
                <img className='aircraft-actions' alt='delete'   onClick={() => removePassenger(index)} src={deleteIcon}/>
                  
                </button>:null}
              </div>
                 
            </div>
          </div>
        ))}

       {createRefund? <button className="uploadImage-button add-passenger-btn" onClick={addPassenger}>
          <div className='flexRow justifyContentCenter alignItemscenter'><span className="small-button-text-regular">+&nbsp;Passenger</span></div>
        </button>:null}
      </div>:null}

      <div className="assign-section">
        <span className='large-button-text-medium margBottom10'>Assign Difference to Sector</span>
           <div className="margTop10"></div>
          <CustomSelect
          options={sectorSelectOptionsList}
          placeHolder="Search Sector..."
          autoWidth={true}
          rightMargin={'1.25rem'}
          value={sectorSelected}
          onChange={(val)=>setSectorSelected(val)}
          />
      </div>

      <div className="card-sales-section">
        <div className="card-totals">
          <div className="total-box">
            <label>Card Sales from POS ({getCultureFromLs().currency.code})</label>
            <div className="total-value">
            <FaRegCreditCard />
              <span>{cardSalesFromPOS}</span>

            </div>
          </div>

          <div className="total-box">
            <label>Card Sales Declared ({getCultureFromLs().currency.code})</label>
            <div className="total-value">
              <IoMdCard/>
              <input
                type="number"
                step="1"
                min='0'
                value={cardSalesDeclared}
                onChange={(e) => setCardSalesDeclared(parseFloat(e.target.value)||"")}
                placeholder="0"
              />
            </div>
          </div>

          <div className="total-box">
            <label>Card Difference</label>
            <div className="total-value dark">
              <span>{cardDifference}</span>
            </div>
          </div>
        </div>
      </div>

      <>
       {createDeposit?<> <button className="done-button margRight15" onClick={saveUserDeposits} disabled={!state.userSelected|| (mode.edit && !editDeposit) }>
          Submit Deposit
        </button>
        <button className="uploadImage-button" onClick={()=>setState((prev)=>({...prev,addComment:true}))}>
          Add Comment
        </button></>:null}
      </>

   {viewCashDeposits ?   <div className="catering-groups-section">
        <div className="flexRow alignItemsCenter section-header margTop0">
<span className='margTop0'>
  <PiSuitcaseLight size={20} style={{ color: '#fff' }} className="scanqr-uplift" />
</span>
<span className='large-button-text-medium'>
  {listItemsLabel()}
</span>
 </div>
   <div className="table-header"></div>
    <div id='myGrid'className="ag-theme-alpine-dark no-wrap" style={{
    height: Math.max((listingItems.items?.length ?? 1) * 42 + 42, 107) + 'px'
  }}>
      <AgGridReact
        id="ngo-grid"
        rowSelection="multiple"
        suppressCellFocus={true}
        className="ngo-grid"
        getRowStyle={() => ({ cursor: 'pointer'})}
          getRowClass={(params) => {
        return params.node.rowIndex % 2 === 0 ? 'tableEvenRowClass' : '';
        }}
        onGridReady={(params) => {
        if (!listingItems?.items?.length) {
        params.api.showNoRowsOverlay();
        }
        }}
        rowData={listingItems.items || []}
        columnDefs={columns}
        onRowClicked={onRowClicked} 
      />
    </div>

      </div>:null}

    </div> 
      <ToastContainer  position="top-center"  
  hideProgressBar={true}
   toastStyle={{ fontSize: '1rem' }} 
  newestOnTop={true}
  rtl={false}
  pauseOnFocusLoss={false}
  draggable={false}
  pauseOnHover ={false}
  />

      {
       state && state.addComment ?
        <EditModal
          isSubModal
          customModalStyle={{height:'40vh',overflowY:'hidden'}}
          showFieldsInColumn
          title={'Add Comment'}
          fields={
            RemarkFormFields.map((_) => ({ ..._, initialValue: state.remarks || '' }))
          }
          onSubmit={handleUpdatedRemarks}
          onClose={closeModal}>
        </EditModal>
     :null }
     {
     !ready &&<div className='overlay_hide sub'></div>
      }
  
    </div>
  );
};
